import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import styled from 'styled-components'

const CssHome = styled.div`

    .hero {
        font-family: Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
        color: white;
        -webkit-font-smoothing: antialiased;
        font-smoothing: antialiased;
        background-image: url("/bg-hero.png");
        height: 536px;
        background-position: center;
        background-size: cover;
        font-size: 14px;
    }

    .hero h2 {
        font-size: 6em;
        font-weight: 600;
    }

    .hero h3 {
        font-size: 1.5em;
        font-weight: 400;
    }

`;

const Home = (props) => {

        return (
            <CssHome>
                <Container fluid={true}>
                    <Row className="hero align-items-center">
                        <Col xs={12}>
                            <h2>
                                <center>Créez en grand.</center>
                            </h2>
                            <h3>
                                <center>L'API de Resamania v2 permet une expérience 360° grâce à l'intégration dans vos apps personnalisées.</center>
                            </h3>
                        </Col>
                    </Row>
                </Container>
            </CssHome>
        );

}


export default Home;


// WEBPACK FOOTER //
// ./src/components/Home.js